'use strict';

export default function TextInput({ 
    className = 'input',
    type = 'text',
    value,
    onChange,
    ...props 
}) {
    return <React.Fragment>
        {props.label && <label>{props.label}</label>}
        <input type={type} value={value} onInput={(event) => onChange(event.target.value)} className={className} {...props} />
    </React.Fragment>
}